import { ProductConstants } from '../../constants/ProductConstants';
import { HostContext } from '../../embed-script/HostContext';

const STANDALONE_HOST_ID = 'standalone';

/**
 * Client mirror of the backend HumanHandoverEligibility gate (webapi/LiveChat/HumanHandoverEligibility.cs):
 * host id eAccounting/standalone + country SE + an eAccounting product of any variant. Kept in sync so the
 * client skips live-chat calls the server would answer with a concealing 404.
 *
 * Lives outside EscalateToHumanButton so the SignalR module can use it: importing the component would
 * pull CustomerLiveChatService (a BaseService subclass) into that module's static import graph and
 * close the BaseService → store → signalR cycle (#2175).
 */
export const isHandoverEligible = (hostContext: HostContext): boolean => {
    const eAccounting = ProductConstants.EAccounting.ProductName.toLowerCase();
    const id = (hostContext.id ?? '').toLowerCase();
    if (id !== eAccounting && id !== STANDALONE_HOST_ID) {
        return false;
    }
    if ((hostContext.country ?? '').toLowerCase() !== 'se') {
        return false;
    }
    return !!hostContext.products?.some((p) => p.name.toLowerCase() === eAccounting);
};
